const Hook = {
    BEFORE_VALIDATE: 'before:validate',
    BEFORE_SAVE: 'before:save',
    AFTER_SAVE: 'after:save'
}

export {Hook}
